var _dec, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import './cg-notification-bell.scss';
import { NotificationService } from 'services/notification-service';
import { inject, bindable, observable } from 'aurelia-framework';
import { SignalRService } from 'services/signalr-service';
import { Router } from 'aurelia-router';
import { SessionService } from 'services/session-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ClearationTimeoutValueConverter } from 'resources/value-converters/clearation-timeout';
import { FadingFunctionality } from 'resources/extensions/fading_functionality';
import { ToastService } from 'services/toast-service';
import { ToastType } from 'resources/helpers/enums';
export let CgNotificationBell = (_dec = inject(Router, NotificationService, SignalRService, EventAggregator, SessionService, ClearationTimeoutValueConverter, ToastService), _dec(_class = (_class2 = class CgNotificationBell extends FadingFunctionality {
  constructor(router, notificationService, signalRService, eventAggregator, sessionService, clearationTimeoutValueConverter, toastService) {
    super();
    this.user = void 0;
    _initializerDefineProperty(this, "selectOptions", _descriptor, this);
    this.unreadNotifications = void 0;
    this.notificationsHidden = false;
    this.clickedOption = [{
      selection: 'all',
      active: true
    }];
    this.notifications = [];
    this.unreadNotificationsCount = 0;
    this.filteredNotifications = [];
    this.loading = void 0;
    this.anyIsChecked = false;
    this.isAnUnread = true;
    this.notificationSubscriber = void 0;
    this.checkboxSelect = void 0;
    this.isHoverOnBell = false;
    _initializerDefineProperty(this, "openDropdown", _descriptor2, this);
    this.windowWidth = void 0;
    this.sizeSubscription = void 0;
    this.search = '';
    this.newNotifications = [];
    this.previousNotifications = [];
    this.toastSearchSent = false;
    this.changeSearchWatch = void 0;
    this.timeouts = [];
    this.simpleBarElement = void 0;
    this.simpleBar = void 0;
    this.clickEvent = false;
    this.profileIsHovered = false;
    this.profileIsHoveredSubscriber = void 0;
    this.anyChecked = notifications => notifications.some(n => n.checked);
    this.anyShow = notifications => notifications.some(n => n.show);
    this.router = router;
    this.notificationService = notificationService;
    this.signalRService = signalRService;
    this.eventAggregator = eventAggregator;
    this.sessionService = sessionService;
    this.clearationTimeoutValueConverter = clearationTimeoutValueConverter;
    this.toastService = toastService;
  }
  async attached() {
    this.user = await this.sessionService.getProfile();
    this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.user = await this.sessionService.getProfile();
    await this.getNotifications();
    this.setupNotificationListener();
    this.handleEventSubscriptions();
    this.setScrollContainer(this.notificationScrollbar);
    this.reinstanceScrollbar();
    this.createScrollEvent();
  }
  detached() {
    this.notificationSubscriber?.dispose();
    this.sizeSubscription?.dispose();
    this.profileIsHoveredSubscriber?.dispose();
    document.removeEventListener('click', this.clickOutsideEvent);
  }
  handleEventSubscriptions() {
    this.notificationSubscriber = this.eventAggregator.subscribe('get-unread-notifications', async () => {
      await this.getNotifications();
    });
    this.sizeSubscription = this.eventAggregator.subscribe('size-changed', payload => {
      this.windowWidth = payload.width;
    });
    this.clickOutsideEvent = document.addEventListener('click', event => {
      if (this.clearingSearch) {
        this.clearingSearch = false;
        return;
      }
      const currentElementClicked = event.target.closest('cg-notification-bell');
      if (!currentElementClicked) {
        this.clickEvent = this.openDropdown = this.isHoverOnBell = false;
      } else {
        this.openDropdown = !this.openDropdown;
        this.isHoverOnBell = this.openDropdown;
        this.eventAggregator.publish('navbar-dropdowns-hover', {
          notificationsIsHovered: this.openDropdown
        });
      }
    });
    this.profileIsHoveredSubscriber = this.eventAggregator.subscribe('navbar-dropdowns-hover', payload => {
      if (!Object.keys(payload).includes('profileIsHovered')) return;
      this.profileIsHovered = payload.profileIsHovered;
    });
  }
  setActiveOption(clickedOption) {
    this.showNew = this.showOld = false;
    if (clickedOption.length > 0) {
      this.filteredNotifications.forEach(notification => {
        switch (clickedOption[0]?.selection) {
          case 'all':
            this.selectOptions.forEach(x => x.active = true);
            notification.checked = true;
            notification.show = true;
            break;
          case 'read':
            notification.checked = notification.show = Boolean(notification.isRead);
            this.showOld = true;
            break;
          case 'unread':
            notification.checked = notification.show = Boolean(!notification.isRead);
            this.showNew = true;
            break;
          case 'none':
            notification.checked = false;
            notification.show = false;
            break;
          default:
            notification.show = true;
            break;
        }
      });
    } else {
      this.filteredNotifications.forEach(notification => {
        notification.show = true;
        notification.checked = false;
      });
    }
    this.setShowElements();
    this.showFade();
  }
  async getUnreadNotifications() {
    this.unreadNotificationsCount = this.user ? await this.notificationService.getAllUnreadCount(this.user.id) : [];
    this.filteredNotifications = this.notifications;
    this.groupingNotifications();
  }
  async getNotifications() {
    this.loading = true;
    this.notifications = this.user ? await this.notificationService.getLatestNotifications(this.user.id, 30, false) : [];
    this.notifications.forEach(notification => {
      notification.show = true;
    });
    this.filteredNotifications.forEach(notification => {
      notification.checked = false;
    });
    this.anyIsChecked = false;
    await this.getUnreadNotifications();
    this.groupingNotifications();
    this.setActiveOption(this.selectOptions.filter(option => option.active));
    this.reinstanceScrollbar();
    this.loading = false;
  }
  async markNotificationsAsRead() {
    if (!this.anyIsChecked) return;
    this.filteredNotifications.forEach(x => x.checked ? x.isRead = this.isAnUnread : null);
    const notificationsId = this.filteredNotifications.filter(item => item.checked).map(x => x.id);
    await this.notificationService.markAsRead(notificationsId, this.isAnUnread);
    this.isAnUnread = true;
    this.eventAggregator.publish('update-all-notifications');
    this.clearOptions();
    await this.getNotifications();
  }
  async markNotificationsAsReadById(id) {
    const currentNotification = this.notifications.find(x => x.id === id);
    const notificationsToMark = this.notifications.filter(x => x.orderId === currentNotification.orderId && x.orderId !== id).map(x => x.id);
    await this.notificationService.markAsRead(notificationsToMark, true);
    this.eventAggregator.publish('update-all-notifications');
    this.clearOptions();
    await this.getNotifications();
  }
  async markNotificationsAsHidden() {
    if (!this.anyIsChecked) return;
    this.notifications.forEach(x => x.isHidden = x.checked);
    const notificationsId = this.filteredNotifications.filter(item => item.checked).map(x => x.id);
    await this.notificationService.markAsHidden(notificationsId);
    this.clearOptions();
    await this.getNotifications();
  }
  async setupNotificationListener() {
    this.setupNotificationListenerInterval = setInterval(async () => {
      const connection = await this.signalRService.getSignalRConnection();
      if (!connection) return;
      connection.on('ShowNotification', notification => {
        this.notifications.unshift(notification);
        this.getUnreadNotifications();
        this.toastService.showToast(ToastType.INFO, notification.description, notification.title);
        this.groupingNotifications();
        this.eventAggregator.publish('update-all-notifications');
      });
      clearInterval(this.setupNotificationListenerInterval);
    }, 1000);
  }
  functionChecked(id) {
    this.selectOptions.forEach(x => x.active = false);
    this.filteredNotifications.forEach(notification => {
      if (notification.id === id) {
        notification.checked = !notification.checked;
        if (!notification.checked) {
          this.checkboxSelectDesktop.au.controller.viewModel.clearExternalCheckbox();
          this.checkboxSelectMobile.au.controller.viewModel.clearExternalCheckbox();
        }
      }
    });
    this.setShowElements();
    if (!this.anyIsChecked) {
      this.filteredNotifications.forEach(notification => {
        notification.show = true;
        notification.checked = false;
      });
      this.groupingNotifications();
    }
  }
  mouseEventsHandler(event) {
    if (this.loading) return;
    switch (event.type) {
      case 'click':
        if (this.clickEvent && !this.openDropdown || this.profileIsHovered) {
          this.openDropdown = !this.openDropdown;
        }
        this.clickEvent = true;
        break;
      case 'mouseenter':
        if (this.profileIsHovered) return;
        this.clickEvent = this.openDropdown;
        if (this.windowWidth > 996 && !this.clickEvent) {
          this.openDropdown = this.windowWidth > 996 && !this.clickEvent;
        }
        break;
      case 'mouseleave':
        if (!this.clickEvent) {
          this.openDropdown = false;
        }
        break;
      default:
        break;
    }
    if (this.windowWidth <= 996) {
      this.eventAggregator.publish('opened-veriff-dialog', {
        openedVeriffDialog: this.openDropdown,
        triggerDeviceStyling: true
      });
    }
    this.isHoverOnBell = this.openDropdown;
    if (!this.openDropdown) {
      this.clearSearch();
      this.notificationScrollbar.querySelector('#notificationList > div.simplebar-wrapper > div.simplebar-mask > div > div').scrollTo({
        top: 0
      });
    }
    this.showFade();
  }
  clearSearch() {
    this.clearingSearch = true;
    this.search = '';
    this.filteredNotifications = this.notifications;
    this.clearOptions();
    this.groupingNotifications();
  }
  groupingNotifications() {
    this.newNotifications = this.filteredNotifications.filter(notification => !this.notificationsHidden && !notification.isRead);
    this.previousNotifications = this.filteredNotifications.filter(notification => !this.notificationsHidden && notification.isRead);
    this.setShowElements();
    this.showFade();
  }
  keyUpHandler(ev) {
    this.toastSearchSent = false;
    this.timeouts = [this.changeSearchWatch];
    this.clearationTimeoutValueConverter.toView(this.timeouts);
    if (ev.key === 'Enter') {
      this.searchNotification();
      return;
    } else {
      this.changeSearchWatch = setTimeout(() => {
        if (this.search) {
          this.searchNotification();
        } else {
          this.filteredNotifications = this.notifications;
          this.clearOptions();
          this.groupingNotifications();
        }
      }, 1500);
    }
    return true;
  }
  async searchNotification() {
    if (!this.search) {
      this.setActiveOption(this.selectOptions.filter(option => option.active));
      return;
    }
    this.timeouts = [this.changeSearchWatch];
    this.clearationTimeoutValueConverter.toView(this.timeouts);
    this.filteredNotifications = this.notifications;
    const relevantNotifications = this.filteredNotifications.filter(notification => {
      return notification.title?.toLowerCase().includes(this.search.toLowerCase()) || notification.description?.toLowerCase().includes(this.search.toLowerCase());
    });
    if (relevantNotifications.length === 0) {
      if (this.toastSearchSent === false) {
        this.toastService.showToast(ToastType.INFO, 'Couldn\'t find anything', 'Try again');
        this.toastSearchSent = true;
      }
    }
    this.filteredNotifications = relevantNotifications;
    this.groupingNotifications();
  }
  async deleteNotifications() {
    if (!this.anyIsChecked) return;
    const notificationsId = this.filteredNotifications.filter(item => item.checked).map(x => x.id);
    if (notificationsId.length > 0) {
      await this.notificationService.delete(notificationsId);
      this.isAnUnread = true;
      await this.getNotifications();
      this.filteredNotifications.forEach(item => item.checked = false);
      this.eventAggregator.publish('get-unread-notifications');
    }
    this.clearOptions();
    this.groupingNotifications();
  }
  setShowElements() {
    this.anyIsChecked = this.anyChecked(this.filteredNotifications);
    this.anyNewChecked = this.anyChecked(this.newNotifications);
    this.anyOldChecked = this.anyChecked(this.previousNotifications);
    this.isAnUnread = !this.anyIsChecked || this.filteredNotifications.some(notification => !notification.isRead && notification.checked);
    this.anyNewNotifications = this.anyShow(this.newNotifications);
    this.anyOldNotifications = this.anyShow(this.previousNotifications);
    this.noResult = !this.anyShow(this.filteredNotifications);
  }
  clearOptions() {
    this.checkboxSelectDesktop.au.controller.viewModel.clearOptionsSelection();
    this.checkboxSelectMobile.au.controller.viewModel.clearOptionsSelection();
  }
  showFade() {
    setTimeout(() => {
      if (!this.notificationScrollbar) return;
      const addFade = this.notificationScrollbar.querySelector('.simplebar-content').clientHeight > 560;
      this.notificationScrollbar.classList.toggle('touching-bottom', !addFade);
    }, 100);
  }
  closeDropdownMobile() {
    this.openDropdown = this.clickEvent = false;
    this.eventAggregator.publish('opened-veriff-dialog', {
      openedVeriffDialog: this.openDropdown,
      triggerDeviceStyling: true
    });
    this.clearSearch();
    this.notificationScrollbar.querySelector('#notificationList > div.simplebar-wrapper > div.simplebar-mask > div > div').scrollTo({
      top: 0
    });
    this.showFade();
  }
  openDropdownChanged(newValue) {
    this.eventAggregator.publish('navbar-dropdowns-hover', {
      notificationsIsHovered: newValue
    });
    if (!newValue) {
      this.clearSearch();
      this.showFade();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectOptions", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [{
      selection: 'all',
      active: false
    }, {
      selection: 'read',
      active: false
    }, {
      selection: 'unread',
      active: false
    }];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "openDropdown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class2)) || _class);